import { useQuery } from 'react-query';

import type { RichAccessToken } from '@evenfinancial/auth-client';

import type { GetRichAccessTokenQuery, ProfileMeta } from '@portal/api-models';

import { client } from '../client';
import type { CustomQueryOptions } from '../types';
import { QueryKey } from '../types';

export const getProfileMeta = async () =>
  client.get<ProfileMeta>('/auth/me').then(({ data }) => data);

/**
 * React Query hook to fetch current user profile metadata.
 *
 * Returns user permissions, roles, scopes, feature flags, and profile data.
 * This replaces Redux state for user permissions in App Router pages.
 */
export const useGetProfileMeta = (options?: CustomQueryOptions) =>
  useQuery({
    ...options,
    queryFn: getProfileMeta,
    queryKey: [QueryKey.ProfileMeta],
    staleTime: 5 * 60 * 1000, // 5 minutes - permissions don't change often
  });

export const getRichAccessTokens = async (params: GetRichAccessTokenQuery) =>
  client
    .get<RichAccessToken[]>('/auth/rich_access_tokens', { params })
    .then(({ data }) => data);
